import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'


Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/home' },
  {
    path: '/home',
    component: () => import('@/views/Home/index.vue')
  },
  {
    path: '/user',
    component: () => import('@/views/UserHome/index.vue'),
    redirect: '/',
    children: [
      {
        path: '/',
        component:
          () => import('@/views/UserHome/Home.vue')
      },
      {
        path: 'likes',
        component:
          () => import('@/views/UserHome/Likes.vue')
      },
      {
        path: 'playlists',
        component:
          () => import('@/views/UserHome/PlayLists.vue')
      },
      {
        path: 'about',
        component:
          () => import('@/views/UserHome/About.vue')
      }
    ]
  },
  {
    path: '/userinfo',
    redirect: '/userinfo/update',
    component: () => import('@/views/UserInfo/index.vue'),
    children: [
      {
        path: 'update',
        component:
          () => import('@/views/UserInfo/Update')
      },
      {
        path: 'phone',
        component:
          () => import('@/views/UserInfo/Phone')
      },
      {
        path: 'password',
        component:
          () => import('@/views/UserInfo/Phone')
      },
      {
        path: 'cancel',
        component:
          () => import('@/views/UserInfo/Phone')
      },
    ]
  },
  {
    path: '/mymusic',
    redirect: '/mymusic/likes',
    component: () => import('@/views/MyMusic.vue'),
    children: [
      {
        path: 'likes',
        component:
          () => import('@/views/UserHome/Likes.vue')
      },
      {
        path: 'playlists',
        component:
          () => import('@/views/UserHome/PlayLists.vue')
      },
      {
        path: 'playHistory',
        component:
          () => import('@/views/UserHome/PlayHistory')
      }
    ]
  },
  {
    path: '/toplist',
    component: () => import('@/views/TopList/index.vue')
  },
  {
    path: '/playlists',
    component: () => import('@/views/PlaylistDetails/index.vue')
  },
  {
    path: '/discover/artist',
    component: () => import('@/views/SingerList/index.vue')
  },
  {
    path: '/discover/playlist',
    component: () => import('@/views/Playlists/index.vue')
  },
  {
    path: '/login',
    component: () => import('@/views/Login/index.vue')
  },
  //歌曲详情
  {
    path: '/songdetails',
    component: () => import('@/views/SongDetails/index.vue')
  },
  //歌手详情
  {
    path: '/singerdetails',
    component: () => import('@/views/SingerDetails.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import('@/views/404/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history', // 去掉url中的# require service support
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let reg = /^\/user|userinfo/
    if (reg.test(to.path)) {
      return savedPosition;
    }
    // 始终滚动到顶部
    return { y: 0 }
  }
})

// 前置导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 从哪个路径跳转而来
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr && /^\/user/.test(to.path)) return next('/')

  // document.body.style.overflow = "hidden";
  store.commit('LOADING_STATUS', true)
  // this.$store.commit('loadStatus', true)
  // setInterval(() => {
  // store.commit('LOADING_STATUS', false)
  // document.body.style.overflow = "visible";
  // }, 500);
  next()
})

// 后置导航守卫
router.afterEach((to, from) => {
  store.commit('LOADING_STATUS', false)
})

export default router
